export function ruleUsesLevel(
  ruleCriterias: Record<string, unknown> | null | undefined,
  levelId: string,
): boolean {
  if (!ruleCriterias || !levelId) {
    return false;
  }

  const criteriaString = JSON.stringify(ruleCriterias);
  // FIXME https://gitlab.service.ops.internal.qualif.io/loyalty/loyalty/-/issues/1351
  const inLevelIdRegExp = RegExp(`\\[\\{"var":"level"},\\[[^[]*"${levelId}"[^\\]]*]\\]`);

  return (
    criteriaString.includes(`[{"var":"level"},"${levelId}"]`) ||
    inLevelIdRegExp.test(criteriaString)
  );
}
